import { sum } from 'lib/array/arrayUtils'

export const TRANSFERZ_MEET_GREET_EXTRA_TYPE = 'MEET_GREET'

export function getIncludedTransferzExtras(
  availableExtras: Array<App.ExperienceTransferExtra> | undefined,
): Array<App.ExperienceTransferSelectedExtra> | undefined {
  const includedExtras = availableExtras
    ?.filter(extra => extra.type === TRANSFERZ_MEET_GREET_EXTRA_TYPE && extra.price === 0)
    .map(extra => ({
      id: extra.id,
      title: extra.title,
      price: extra.price,
      quantity: 1,
    }))

  return includedExtras?.length ? includedExtras : undefined
}

export function hasSelectedIncludedTransferzMeetGreet(
  availableExtras: Array<App.ExperienceTransferExtra> | undefined,
  selectedExtras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): boolean {
  const includedExtraIds = new Set(getIncludedTransferzExtras(availableExtras)?.map(extra => extra.id))

  return selectedExtras?.some(extra => includedExtraIds.has(extra.id) && extra.quantity > 0) ?? false
}

export function getSelectedTransferExtras(
  extras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): Array<App.ExperienceTransferSelectedExtra> | undefined {
  const selectedExtras = extras?.filter(extra => extra.quantity > 0)

  return selectedExtras?.length ? selectedExtras : undefined
}

export function getTransferExtrasTotal(
  extras: Array<App.ExperienceTransferSelectedExtra> | undefined,
): number {
  return sum(getSelectedTransferExtras(extras) ?? [], extra => extra.price * extra.quantity)
}
